import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import { RMSTextField } from '../../../shared/components/form-controls';
import CreateFormResolver from '../../../shared/utility/createFormResolver';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import verifyPinSchema from '../../schema/verifyPinSchema';

const PinEntryDialog = ({
  open,
  title,
  description,
  submitLabel,
  onClose,
  onSubmit,
  onVerified,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    resolver: CreateFormResolver(verifyPinSchema),
    mode: 'onSubmit',
    defaultValues: { pin: '' },
  });

  const handleSubmit = methods.handleSubmit(async (values) => {
    await executeApiAction({
      setLoading,
      dispatch,
      action: () => onSubmit(values.pin),
      onSuccess: (result) => onVerified?.(values.pin, result),
    });
  });

  return (
    <RMSCommonDialog
      open={open}
      title={title}
      onClose={onClose}
      onSave={handleSubmit}
      loading={loading}
      maxWidth="xs"
      fullWidth
      closeOnBackdropClick={false}
      saveButton={{
        show: true,
        type: 'simple',
        label: submitLabel || 'Verify',
        variant: 'contained',
        color: 'primary',
      }}
      dialogClassName="pin-entry-dialog">
      <FormProvider {...methods}>
        {description && <p className="pin-entry-description">{description}</p>}
        <RMSTextField name="pin" label="PIN" type="password" autoComplete="off" />
      </FormProvider>
    </RMSCommonDialog>
  );
};

export default PinEntryDialog;
